import { createElement } from '../../utils/utils';
import { BaseProps } from '../../types';

export interface Props extends BaseProps {
  text: string;
  href?: string;
  target?: string;
  onClick?(): void;
}

export const Link = (props: Props) => {
  const { text, onClick, className, dataHook, href, target } = props;
  const element = createElement<HTMLAnchorElement>({
    tagName: 'a',
    className,
    dataHook,
  });
  if (href) {
    element.href = href;
  }
  if (target) {
    element.target = target;
  }
  element.innerText = text;

  if (onClick) {
    element.onclick = onClick;
  }

  return element;
};
